import defaultStorage from '@hc-frontend/shared-assets/src/js/sem/storage-manager/defaultStorage'
import { IS_ENROLL } from 'core/constants/environment'
import getURLParams from 'utils/DOM/getURLParams'
import { deepClone, propAccessor } from '@hc-frontend/utils'
import storage from 'proxy-storage'

export const initHcStorage = clearStorage => {
  const queryParams = getURLParams()
  const resetHcStorage = clearStorage || queryParams['quoteKey']

  // Clean up enrollment data on non-thank-you pages
  const pathName = propAccessor(window, 'location.pathname') || ''
  const enrolment = storage.getItem('enrollment')
  if (!pathName.includes('/thank-you') && enrolment) {
    storage.removeItem('enrollment')
  }

  let hcStorage = storage.getItem('hc') as Pivot.Store

  if (resetHcStorage || !hcStorage) {
    hcStorage = deepClone(defaultStorage)
    storage.setItem('hc', hcStorage)
  }

  if (IS_ENROLL && hcStorage.members.length === 0) {
    hcStorage.members = [
      {
        id: 'primary',
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        phone: '',
        phoneIsMobile: false,
        type: 'primary',
        gender: '',
        dob: '',
        age: 0,
        height: {
          feet: '',
          inches: ''
        },
        weight: '',
        stringDOB: ''
      }
    ]
    storage.setItem('hc', hcStorage)
  }

  return hcStorage
}

export const getHcStorageFromQuery = () => {
  const queryParams = getURLParams()
  let hcStorage, contact, primaryMember, spouseMember, members

  const dob = queryParams['dob']
  const gender = queryParams['gender']
  const firstName = queryParams['fname']
  const lastName = queryParams['lname']

  if (firstName || lastName) {
    contact = {
      first_name: firstName,
      last_name: lastName
    }
    primaryMember = {
      firstName,
      lastName,
      id: 'primary',
      type: 'primary',
      stringDOB: dob,
      gender
    }
  }

  const spouseDob = queryParams['dob_s']
  const spouseGender = queryParams['gender_s']
  if (spouseDob || spouseGender)
    spouseMember = {
      id: 'spouse',
      type: 'spouse',
      gender: spouseGender,
      stringDOB: spouseDob
    }

  const children = ['_1', '_2', '_3', '_4', '_5', '_6', '_7', '_8', '_9']
    .map(suffix => {
      const dobKey = `dob${suffix}`
      const genderKey = `gender${suffix}`
      if (queryParams[dobKey] || queryParams[genderKey])
        return {
          id: `child${suffix}`,
          type: 'child',
          stringDOB: queryParams[dobKey],
          gender: queryParams[genderKey]
        }
    })
    .filter(Boolean)

  if (contact) {
    if (!hcStorage) hcStorage = {}
    hcStorage = {
      ...hcStorage,
      contact
    }

    if (!members) members = []
    members.push(primaryMember)
  }

  if (spouseMember) {
    if (!members) members = []
    members.push(spouseMember)
  }

  if (children.length > 0) {
    if (!members) members = []
    members = members.concat(children)
  }

  if (members && members.length > 0) {
    if (!hcStorage) hcStorage = {}
    hcStorage = {
      ...hcStorage,
      members
    }
  }

  return hcStorage
}

export const mergeHcStorage = (base, override) => {
  const objects = ['channel', 'contact', 'agentInfo', 'utm', 'location']
  let mergedMembers = []

  const mergedKeys = objects.reduce((acc, objKey) => {
    const baseData = base && base[objKey] ? base[objKey] : undefined
    const overrideData = override && override[objKey] ? override[objKey] : undefined
    if (base) {
      acc[objKey] = {
        ...(baseData || {}),
        ...(overrideData || {})
      }
    }
    return acc
  }, {})

  const baseMembers = base && base.members ? base.members : []
  const overrideMembers = override && override.members ? override.members : []

  if (baseMembers.length > 0 || overrideMembers.length > 0) {
    const memberKeys = [
      'primary',
      'spouse',
      'child_1',
      'child_2',
      'child_3',
      'child_4',
      'child_5',
      'child_6',
      'child_7',
      'child_8',
      'child_9'
    ]

    mergedMembers = memberKeys
      .map(key => {
        const baseMember = baseMembers.find(m => m.id === key)
        const overrideMember = overrideMembers.find(m => m.id === key)

        if (baseMember || overrideMember) {
          return {
            ...(baseMember || {}),
            ...(overrideMember || {})
          }
        }
      })
      .filter(Boolean)
  }

  return {
    ...base,
    ...mergedKeys,
    members: mergedMembers
  }
}
